import React, { useEffect, useState } from "react";
import loading from "../assets/loading.svg";

const Loading = () => {
  const [dotNum, setDotNum] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setDotNum((s) => (s + 1) % 4);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return (
    <div className="spinner" style={{ color: "#4C4C4C" }}>
      <div>
        <img src={loading} alt="Loading" />
      </div>
      <div style={{ marginTop: 20 }}>
        <span role="img" aria-label="star">
          ✨
        </span>
        Sit back, we are summoning the magic{Array(dotNum).fill(".").join("")}
      </div>
    </div>
  );
};

export default Loading;
